import { FC } from "react";
import { MenuToggleProps } from "../types";

const Settings: FC<MenuToggleProps> = () => <></>;
export default Settings;